import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';

const chipsMIN10k = [
  {
    color: CHIPS_COLORS.BLUE,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 20e3,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 50e3,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 100e3,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 200e3,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 500e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 1e6,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 5e6,
  },
];

export const CHIPS_MIN_10k: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 2e3,
  },
  ...chipsMIN10k,
];

export const CHIPS_MIN_10k_v2: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 2.5e3,
  },
  ...chipsMIN10k,
];
